import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataStoreService } from '../data-store.service';

@Component({
  selector: 'app-tassa-auto',
  templateUrl: './tassa-auto.component.html',
  styleUrls: ['./tassa-auto.component.scss']
})
export class TassaAutoComponent implements OnInit {

  constructor(
    public dataStore:DataStoreService,
    private router: Router
    ) { }

  ngOnInit() {
    this.dataStore.resetText();
    window.scrollTo(0,0);
  }

  goToContact(preText: string) {
   this.dataStore.updateText(preText);
   this.router.navigate(['/contatti']).then();
  }
}
